import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";

import {Carteira} from "../carteira.model";
import {MaskUtil} from "../../shared/util/mask-util";
import {PaginationComponent} from "maps-angular-components";
import {PaginationResponse} from "../../shared/form/pagination-response";

@Component({
  selector: 'app-carteira-lista',
  templateUrl: './carteira-lista.component.html',
  styleUrls: ['./carteira-lista.component.scss']
})
export class CarteiraListaComponent implements OnInit {

  page = 1;
  totalPages = 0;
  pageSize = 20;
  allElements: Carteira[] = [];
  totalElements = 0;
  dataSource: Carteira[] = [];
  paginatedDataSource: Carteira[][];
  paginationTotalPage = 1;

  selectedCarteiras: Carteira[] = [];
  @Output() pageRequested = new EventEmitter<number>();
  @Output() itemSelected = new EventEmitter<number>();

  @ViewChild("allCheckbox", {static: true}) allCheckbox: MatCheckbox;

  @ViewChild("pagination", {static: false}) pagination: PaginationComponent;

  constructor() { }


  ngOnInit() {
  }

  updateDatasource(data: PaginationResponse) {
    this.allElements = data.content;
    this.totalElements = data.metadata.totalElements;
    this.totalPages = data.metadata.totalPages;
    this.selectedCarteiras = [];
    this.allCheckbox.checked = false;
    this.itemSelected.emit(this.selectedCarteiras.length);
  }

  public formatCnpj(cnpj: string) {
    return MaskUtil.formatCnpj(cnpj);
  }

  selectAll($event: MatCheckboxChange) {
    if ($event.checked) {
      this.allElements.filter(item => !this.selectedCarteiras.includes(item)).forEach(item => this.selectedCarteiras.push(item));
    } else {
      this.selectedCarteiras = [];
    }

    this.itemSelected.emit(this.selectedCarteiras.length);
  }

  updateSelected($event: MatCheckboxChange, carteira: Carteira) {
    if ($event.checked) {
      this.selectedCarteiras.push(carteira);
    } else {
      const index: number = this.selectedCarteiras.indexOf(carteira);
      this.selectedCarteiras.splice(index, 1);
    }
    this.allCheckbox.checked = this.allSelected();
    this.itemSelected.emit(this.selectedCarteiras.length);
  }

  carteiraChecked(carteira: Carteira): boolean {
    return this.selectedCarteiras.find(cart => cart === carteira) != null;
  }

  allSelected(): boolean {
    return this.selectedCarteiras.length === this.allElements.length && this.allElements.length > 0;
  }

}
